<template>
  <div class="">
    <form @submit.prevent="submit">
      <AdvanceDescription1 v-model="orderDescription" :itemClass="itemClass" :inputs-config="questions"/>

      <teleport to="body">
        <div class="modal fade show" id="cashOnDelivery" tabindex="-1"
             aria-labelledby="exampleModalLabel"
             aria-hidden="true">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">

                <m-un-authenticated-shopping-cart2
                    v-if="showUnAuthenticatedComponent"
                    :hide-signup-button="false"
                    :hideRefreshShoppingCartButton="false"
                    :addressRequired="false"
                    :orderDescriptionValueProp="orderDescription"
                    :disableSelectedCityWatch="false"
                    :showProductListProp="false"
                    :defaultLocation="true"
                    defaultCityId="1"
                    defaultProvinceId="1"
                />

              </div>
            </div>
          </div>
        </div>
      </teleport>


      <div class="row justify-content-center">
        <button type="submit" class="btn btn-primary px-5">ثبت</button>
      </div>

    </form>
  </div>
</template>


<script>
import AdvanceDescription1 from "../../AdvanceDescription/AdvanceDescription1.vue";
import mUnAuthenticatedShoppingCart2 from "../../UnAuthenticatedShoppingCart/UnAuthenticatedShoppingCart2.vue";
import $ from 'jquery'
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";

export default {
  name: "FormQuestions1",
  components: {mUnAuthenticatedShoppingCart2, AdvanceDescription1},
  props: {
    questions: {},
    productLink: {},
    itemClass: {
      default: 'col-lg-12'
    }
  },
  data() {
    return {
      $,
      showUnAuthenticatedComponent: false,
      product: {},
      orderDescription: ''
    }
  },
  methods: {
    ...shoppingCartFunctions,
    submit() {
      this.addProductToUnAuthenticatedShoppingCart()
      console.log('submit')
    },
    async addProductToUnAuthenticatedShoppingCart() {

      this.showUnAuthenticatedComponent = false
      await localStorage.removeItem('products')

      await this.addUnAuthItem(this.product, null, null, false)

      await $('#cashOnDelivery').modal('show')
      this.showUnAuthenticatedComponent = true

      let storageEvent = new Event(`unauthenticatedShoppingCardDescriptionEmpty`);
      window.dispatchEvent(storageEvent);

    },
  },
  async mounted() {
    let req = await this.$store.dispatch('Product/getProductWithoutState', this.productLink)
    this.product = req.data.data
  }
}
</script>

<style scoped>

</style>